// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1DWzw","inputWrap":"Table_inputWrap__15hLc","col":"Table_col__1WeRH","bmiTooltip":"Table_bmiTooltip__2Iq-n"};